<template>
  <b-container fluid id="main-container">
    <div>
      <b-table :items="items" :fields="fields">
        <template #cell(id)="data">
            <span>{{data.value}}</span>
        </template>
        <template #cell(email)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].email"></b-form-input>
            <span v-else>{{data.value}}</span>
        </template>
        <template #cell(password_hash)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].password_hash"></b-form-input>
            <span v-else>{{data.value}}</span>
        </template>
        <!--
        <template #cell(department)="data">
          <b-form-select v-if="items[data.index].isEdit" v-model="items[data.index].email" :options="['Development', 'Marketing', 'HR', 'Accounting']"></b-form-select>
          <span v-else>{{data.value}}</span>
        </template>
        -->
        <template #cell(authenticated)="data">
             <b-form-checkbox v-if="items[data.index].isEdit" v-model="items[data.index].authenticated" value="1" unchecked-value="0"></b-form-checkbox>
             <span v-else>{{data.value}}</span>
        </template>
        <template #cell(admin)="data">
             <b-form-checkbox v-if="items[data.index].isEdit" v-model="items[data.index].admin" value="1" unchecked-value="0"></b-form-checkbox>
             <span v-else>{{data.value}}</span>
        </template>
        <template #cell(registered_ts)="data">
          <span>{{data.value}}</span>
        </template>
        <template #cell(edit)="data">
          <b-button @click="editRowHandler(data)">
            <span v-if="!items[data.index].isEdit">Edit</span>
            <span v-else>Done</span>
          </b-button>
        </template>
        <template #cell(delete)="data">
          <b-button @click="deleteRow(data)">
            <span>Delete</span>
          </b-button>
        </template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "UserTable",
  components: {},
  mounted() {
    this.$http.get(this.$hostname + '/api/user/list')
      .then(response => { 
        this.items = response.data
        this.items = this.items.map(item => ({...item, isEdit: false}));
      })
      .catch(error => {
        console.error(error);
      });
  },
  data() {
    return {
      fields: [
        { key: "id", label: "ID"},
        { key: "email", label: "Email"},
        { key: "password_hash", label: "Password Hash" },
        { key: "authenticated", label: "Is authenticated" },
        { key: "admin", label: "Is admin" },
        { key: 'registered_ts', label: 'Registration TS'},
        { key: 'edit', label: ''},
        { key: 'delete', label: ''}
      ],
       items: []
    };
  },
  methods: {
      editRowHandler(data) {
        if (this.items[data.index].isEdit) {
          console.log(this.items[data.index])
          this.$http.put(this.$hostname + '/api/user/update', this.items[data.index])
            .then(response => { 
               console.log(response);
            })
            .catch(error => {
              console.error(error);
            });
        }
        this.items[data.index].isEdit = !this.items[data.index].isEdit;
      },
      deleteRow(data) {
        console.log(this.items[data.index])
        this.$http.delete(this.$hostname + '/api/user/' + this.items[data.index].id + '/disable')
          .then(response => { 
             console.log(response);
             this.items.splice(data.index, 1)
          })
          .catch(error => {
            console.error(error);
          });
      },
  }
}
</script>

<style>
thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
}
pre {
  text-align: left;
  color: #d63384;
}
</style>